import Button from 'Components/Base/Button'
import Column from 'Components/Base/Column'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { formatTimeAndTimezone } from 'utilities/formatTimeAndTimezone'

interface Card {
  cardId: number
  title: string
  subText?: React.ReactChild
  buttonText: string
  buttonRoute?: string
  img: string
  dynamic?: boolean
  changeApptStep?: number
  isInitial?: boolean
}

interface props {
  details: Card
  dynamic: boolean
  triaPerson: string
  date: string
  time: string
  handleChangeApptStep: (step: number, isInitial: boolean, cardId: number) => void
}
export default function ScheduleCard({ details, dynamic, triaPerson, date, time, handleChangeApptStep }: props) {
  const navigate = useNavigate()

  return (
    <CardContainer>
      <StyledImage className="app-and-fruit" src={details.img} />
      <TextContainer>
        <Header>{details.title}</Header>
        {dynamic ? (
          <div>
            <Typography>
              You’re scheduled to meet with {triaPerson} on {date} at {formatTimeAndTimezone(time)}.{' '}
            </Typography>
          </div>
        ) : (
          <div>{details.subText}</div>
        )}
        {details.buttonRoute && (
          <Button text={details.buttonText} styles={{ width: 200, marginTop: 15 }} onClick={() => navigate(details.buttonRoute!)} />
        )}
        {details.changeApptStep && (
          <Button
            text={details.buttonText}
            styles={{ width: 200, marginTop: 15 }}
            onClick={() => handleChangeApptStep(details.changeApptStep!, details.isInitial!, details.cardId!)}
          />
        )}
      </TextContainer>
    </CardContainer>
  )
}

const StyledImage = styled.img`
  width: 200px;
  margin: auto 20px auto 0px;
  @media only screen and (max-width: 600px) {
    min-width: 20%;
    margin: 10px auto;
  }
`
const CardContainer = styled.div`
  display: flex;
  width: 1200px;
  margin: 20px auto;
  padding: 30px;
  text-align: left;
  border-radius: 25px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  @media only screen and (max-width: 600px) {
    width: 100%;
    flex-direction: column;
  }
`
const TextContainer = styled(Column)`
  margin: auto auto auto 0px;
`

const Header = styled(Row)`
  font-size: 32px;
  font-weight: 700;
`
